import React, { useContext } from "react";
import { Link } from "react-router-dom";

// Contexts
import { DataContext } from "contexts/Data";

// Internal components
import BeheardLogo from "components/BeheardLogo";

const Nav = ({ className, children }) => {
    const { data, language } = useContext(DataContext);
    return (
        <nav className={`nav ${className}`}>
            <div className="nav__line" />

            <div className="nav__items">
                {/* {data &&
                    Array.isArray(data.pages) &&
                    data.pages.map((p) => (
                        <Link className="nav__items_item" to={p.to[language]}>
                            {p.label[language]}
                        </Link>
                    ))} */}
                {Object.entries(data.pages).map(([key, value]) => (
                    <Link
                        className="nav__items__item"
                        to={value.to[language]}
                        key={key}
                    >
                        {value.label[language]}
                    </Link>
                ))}
                <a
                    className="nav__items__item nav__items__item--beheard"
                    href="https://beheard.no/"
                >
                    <BeheardLogo size="2rem" />
                </a>
            </div>
            {children}
        </nav>
    );
};

export default Nav;
